import getApiInstance from 'data/common/ApiCallGenerique';
import getMiddlewareSocketInstance from '../../environments/myfhe/common/SocketMiddleware';

import api from './api';

/** @var ApiCall api_caller **/
const apiCaller = getApiInstance();

function _logInUser(profile) {
    return {
        type: 'LOGIN_USER',
        user: profile
    };
}

function logInUser(profile) {
    return dispatch => {
        dispatch(_logInUser(profile));
    };
}
function logOutUser() {
    return dispatch => {
        dispatch({
            type: 'LOGOUT_USER'
        });
    };
}
function resetPassword(usernameOrEmail, callback) {
    return dispatch => {
        return apiCaller
            .call(api.password_recovery(usernameOrEmail))
            .then(function(response, responseData) {
                if (callback) callback.call(this, true, responseData);
                dispatch({ type: 'BLANK' });
            })
            .catch(function(e) {
                if (callback) callback.call(this, false, e);
                dispatch({ type: 'BLANK' });
            });
    };
}

export { logInUser, logOutUser, resetPassword };



// WEBPACK FOOTER //
// ./data/user/actions.js